<template>
    <div class="ShopScenes" style="min-height:945px;height:auto;">
		<!-- 场景列表 -->
		<div class="app_container gallery-container" id="gallery" v-on:scroll.native="loadMore">
            <div class="gallery-middle" style="margin-top: 40px;">
				<ul class="gallery-items">
					<li class="gallery-item scene_item" v-for="(item,index) in sceneLists" v-bind:key="item.id" >
                        <div class="scene_img_box" v-if="!item.off_thumb && !item.off_template" v-bind:style="{'background-image' : 'url(\'' + item.thumb + '\'),url(../../static/img/scene-default.png)' }"  @click.stop="item.origin?displayShopScene(item):noPlugInPreviewScene(item,true)" v-bind:title="item.origin?'场景详情':'预览场景'" >
                            <div class="shop_car_box" @click.stop="buyScenes(item)" v-if="false">
                                <i class="fa fa-shopping-cart fa-fw"></i>
                            </div>
                            <div class="sceneicon_box top-left tooltip-box top" @click.stop="showScene" :class="sceneType(item).class" :data-content="sceneType(item).type" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="item.origin">
                                <img src="../../static/img/scene/sceneicon.png" alt="">
                            </div>
                            <div  v-if="!item.origin">
                                <div class="sceneicon_box top-left tooltip-box top"  @click.stop="showScene" :class="sceneType(item).class" data-content="在线搭场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="item.type == 5" style="background: #2fb3ff;">
                                    <img src="../../static/img/scene/online_sceneicon.png" style="width: 16px;height: 16px;position: absolute;top: 3px;left: 4px;" alt="">
                                </div>
                                <div class="sceneicon_box top-left tooltip-box top"  @click.stop="showScene" :class="sceneType(item).class" data-content="tjs场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="item.type == 4" style="background: #2fb3ff;">
                                    <img src="../../static/img/scene/tjs_sceneicon.png"  style="width: 16px;height: 16px;position: absolute;top: 3px;left: 4px;"  alt="">
                                </div>
                            </div>
                            <span class="indexAPP" @click.stop="showScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in item.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="item.isShopping==1" @click.stop="saleItem(item)">购买</div>
                        </div>
                        <div class="scene_img_box" v-if="item.off_thumb" v-bind:style="{'background-image' : 'url(\'' + item.off_thumb + '\'),url(../../static/img/scene-default.png)' }"  @click.stop="item.origin?displayShopScene(item):noPlugInPreviewScene(item,true)" v-bind:title="item.origin?'场景详情':'预览场景'" >
                            <div class="shop_car_box" @click.stop="buyScenes(item)" v-if="false">
                                <i class="fa fa-shopping-cart fa-fw"></i>
                            </div>
                            <div class="sceneicon_box top-left tooltip-box top"  @click.stop="showScene" :class="sceneType(item).class" :data-content="sceneType(item).type" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="item.origin">
                                <img src="../../static/img/scene/sceneicon.png" alt="">
                            </div>
                            <div  v-if="!item.origin">
                                <div class="sceneicon_box top-left tooltip-box top"  @click.stop="showScene" :class="sceneType(item).class" data-content="在线搭场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="item.type == 5" style="background: #2fb3ff;">
                                    <img src="../../static/img/scene/online_sceneicon.png" style="width: 16px;height: 16px;position: absolute;top: 3px;left: 4px;" alt="">
                                </div>
                                <div class="sceneicon_box top-left tooltip-box top"  @click.stop="showScene" :class="sceneType(item).class" data-content="tjs场景" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" v-if="item.type == 4" style="background: #2fb3ff;">
                                    <img src="../../static/img/scene/tjs_sceneicon.png"  style="width: 16px;height: 16px;position: absolute;top: 3px;left: 4px;"  alt="">
                                </div>
                            </div>

                            <span class="indexAPP" @click.stop="showScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in item.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="item.isShopping==1" @click.stop="saleItem(item)">购买</div>
                        </div>
                        <div class="scene_img_box template" v-if="item.off_template" v-bind:style="{'background-image' : 'url(\'' + item.preview + '\'),url(../../static/img/scene-default.png)' }"  @click.stop="item.origin?displayShopScene(item):noPlugInPreviewScene(item,true)" v-bind:title="'预览场景'" >
                            <span class="indexAPP" @click.stop="showScene"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in item.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" @click.stop="checktCampany(item,'templeteCampus')">购买</div>
                        </div>
                        <hr/>
                        <div class="modelList_info">
                            <div class="author_info shop_author_info">
                                <a class="tooltip-box top " v-if="!item.origin" style = "cursor:auto">
                                    <img class="author_headImg scene_author_headImg" :src="item.origin?item.origin.headImg:item.off_template?disposeHeadImg1(item.headImg,'template'):disposeHeadImg1(item.headImg)"/>
                                </a>
                                <a class="tooltip-box top " v-if="item.origin" style = "cursor:auto">
                                    <img class="author_headImg scene_author_headImg" :src="disposeHeadImg(item.headImg)"/>
                                </a>
                                <span class="author_name no-effect" v-html="$options.filters.highLightMsg(item.publicname||item.name)" v-bind:title="item.publicname||item.name"  @dblclick="selectText()">{{item.publicname||item.name}}</span>
                            </div>
                            <div class="model_info" v-if='item.origin'>
                                <div class="model_seen model_time tooltip-box top" v-bind:data-content="item.createtime " v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_price tooltip-box top" data-content="场景售价" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-yen fa-fw"></i>{{item.price}}
                                </div>
                                <div class="model_buy tooltip-box top" data-content="购买次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-shopping-cart fa-fw"></i>{{item.salecount}}
                                </div>
                            </div>
                            <div class="model_info" v-if='!item.origin'>
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="item.createtime?item.createtime:processingTime(item.createTime)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_price tooltip-box top" v-if="item.off_template" data-content="场景售价" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-yen fa-fw"></i>{{item.price}}
                                </div>
                                <div class="model_seen tooltip-box top" v-if="!item.off_template" data-content="资源大小" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-file-archive-o"></i>{{formatBytes(item.resourceSize)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="浏览次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(item.browse)}}
                                </div>
                            </div>
                        </div>
					</li>
				</ul>
			</div>
		</div>
        <div class="modelList_footer">
            <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
            <div class="load_more_btn" v-on:click="loadMore" v-if="!isLastPage&&isLoadComplete">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
            <h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
        </div>
        <!-- 场景详情 -->
        <div class="shadowPage" v-show="showScenePage"></div>
        <div class="shopSceneContainer" v-show="showScenePage">
            <div class="pc-title" >
                <span class="pc-head">场景详情</span>
                <span class="layui-layer-setwin"  @click="showScene()"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
            </div>
            <div class="shopInfoBox clearfix">
                <div class="shopSceneInfoLeft">
                    <div class="shopSceneInfoLeftTop">
                        <div class="shopimgBox">
                            <div class="shopimgLeft" @click="moveLeft"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                            <div class="shopimgRight" @click="moveRight"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                            <div class="progressImg"></div>
                            <ul class="shopimgUl">
                                <li class="shopimgLi"><img :src="displaySceneInfo.thumb" alt=""></li>
                                <li class="shopimgLi"  v-for="(shopimg) in shopImgArr" v-bind:key="shopimg.fileurl">
                                    <img :src="$global.MMD_URL+'SceneShop/'+shopimg.fileurl" alt="">
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="shopSceneInfoLeftBottom">
                        <div class="smallShopimgLeft" @click="moveSmallLeft"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                        <div class="smallShopimgRight" @click="moveSmallRight"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                        <div class="smallShopimgBox">
                            <ul class="smallShopimgUl">
                                <li class="smallShopimgLi smallShopimgLiFirst" @click="focusSmallImg($event)"><img :src="displaySceneInfo.thumb" alt=""></li>
                                <li class="smallShopimgLi"  v-for="(shopimg) in shopImgArr" v-bind:key="shopimg.fileurl" @click="focusSmallImg($event)">
                                    <img :src="$global.MMD_URL+'SceneShop/'+shopimg.fileurl" alt="">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="shopSceneInfoRight">
                    <div class="priceTipBox">购买需要<span>{{displaySceneInfo.price}}</span>元</div>
                    <!-- <div class="saveTipBox">（魔豆充值可享9折）</div> -->
                    <div class="shopDoneloadBox">
                         <button class="btn btn-shop" @click="checkCampany(displaySceneInfo)"><i class="fa fa-shopping-cart"></i> 立即购买</button>
                    </div>
                    <div class="shopDetailBox">
                        <div class="shopDetailLeft floatLeft">
                            <!-- <a href="javascript:;" @click="recharge()"><img class="shopModou" src="../../static/img/modou.png" alt=""> 魔豆充值</a> -->
                        </div>
                        <!-- <div class="shopDetailLine floatLeft"></div> -->
                        <div class="shopDetailRight floatLeft">
                            <span title="浏览量"><i class="fa fa-eye" ></i> 0 </span>
                            <span title="销量"><img class="salesIcon" src="../../static/img/scene/sales.png" alt=""> {{displaySceneInfo.salecount}}</span>
                        </div>
                    </div>
                    <div class="shopLine"></div>
                    <div class="shopScenenameBox" v-html="displaySceneInfo.name">{{displaySceneInfo.name}}</div>
                    <div class="shopDetailsBox" style="display:flex">场景ID：<span style="cursor:pointer;" title="双击复制" @dblclick="copyId()">{{displaySceneInfo.sceneid}}</span></div>
                    <div class="shopDetailsBox">大小：未知</div>
                    <div class="shopDetailsBox">模型种类：{{shopSource.modelsSize}}</div>
                    <div class="shopDetailsBox">贴图种类：{{shopSource.textureImgSize}}</div>
                    <div class="shopDetailsBox">对象/三角面/贴图：{{shopSource.census}}</div>
                    <div class="shopDetailsBox">代码：{{displaySceneInfo.hasScript?displaySceneInfo.hasScript:0}}</div>
                    <div class="shopDetailsBox">描述：{{displaySceneInfo.descr}}</div>
                    <div class="shopLine"></div>
                    <div class="shopAuthor">
                        <div class="shopAuthorTitle" v-if="displaySceneInfo.origin">
                            <div><img :src="displaySceneInfo.headImg"  alt=""></div>
                            {{displaySceneInfo.username}}
                        </div>
                         <div v-if="otherScene" class="otherShopSceneBox" @click="displayShopScene(otherScene)">
                            <img title="点击查看场景详情" :src="$global.MMD_URL+otherScene.thumb"  alt="">
                        </div>
                        <div v-else class="authorNoOtherScene">
                            <img class="noShopSceneImg" src="../../static/img/scene/noscene.png" alt="">
                            该作者无其他场景出售
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="boxHeader">
            <CamanyInfoService @hidePanel="hidePanel" v-show="panelShow" :panelShow="panelShow"></CamanyInfoService>
            <!-- <ModelService @hidePanelD=hidePanelD v-show="panelShowD" :panelShowD="panelShowD"></ModelService> -->
        </div>
        <div v-if="showBuyTCTips" class="layui-layer-shade" id="layui-layer-shade2" times="2" style="z-index: 19891015; background-color: rgb(0, 0, 0); opacity: 0.3;"></div>
        <div v-if="showBuyTCTips" class="layui-layer layui-layer-page" type="page" times="3" showtime="0" contype="string" style="z-index: 19891077;top:50%; left: 50%;width:262px;heigt:160px;margin-left:-115px;margin-top:-80px;">
            <div class="layui-layer-title">温馨提示</div>
            <div id="layerDemoauto" class="layui-layer-content ng-scope">
                <div style="padding: 20px 20px;font-size:14px;" id="layui-layer-info">当前场景为免费场景，您确定复制场景吗？</div>
            </div>
            <span class="layui-layer-setwin" v-on:click="canelBuyTCTips">
                <a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a>
            </span>
            <div class="layui-layer-btn layui-layer-btn-c" style="border-top:1px solid #eee;">
                <a class="layui-layer-btn0" v-on:click="buyZeroTempCampus">确定</a>
                <a class="layui-layer-btn0" v-on:click="canelBuyTCTips" style="color: #333;background: none;border: 1px solid #dedede;">取消</a>
            </div>
        </div>
    </div>
</template>
<script>
    import bus from '../assets/js/eventBus.js';
    import PurchaseModel from './PurchaseModel.vue';
    import CamanyInfoService from './CampanyInfo.vue';
    import shield from '../assets/js/shield.js';
    import ModelService from './ModelService.vue';
    var vm;
    export default {
        name:"ShopScenes",
        components: {
            CamanyInfoService,
            ModelService
        },
        data:function(){
            return{
                headPath:'https://www.thingjs.com/',
                headPath1:'http://www.3dmomoda.com/',
                infoPath:'http://www.3dmomoda.com/scene/info/',
                previewPath:'http://www.3dmomoda.com/browse',
                headBuyPath:'https://www.thingjs.com/3dmomoda/',
                isLastPage:false,
                sceneList:[],//显示列表
                currentClassSceneList:[],
                allSceneList:[],//所有场景列表
                showScenePage:false,
                displaySceneInfo:{},
                shopImgArr:[],
                shopSource:{
                    modelsSize:0,
                    textureImgSize:0,
                    census:0
                },
                otherScene:null,
                currentImgNum:0,
                sceneicon_bg_1:"sceneicon_bg_1",
                sceneicon_bg_2:"sceneicon_bg_2",
                isLoadComplete :false,
                queryData: {
					type:"",
					bigType: "",
					smallType: "",
					keyWord: "",
					pageSize: 24,
					pageNumber: 1,
                    sort: "zonghe",
                    isAPP:false
                },
                panelShow:false,
                singleScene_mmd:'',
                panelShowD:false,
                sceneListType:'',
                showBuyTCTips:false,
                showBuyTCInfos:null,
                otherSceneListAll:[]//该作者所有场景列表
            }
        },
        computed: {
            sceneLists(){
                let result = this.sceneList.map((item,index,arr)=>{
                    try{
                        if(!item.thumb.includes('http')){
                            arr[index].thumb = this.$global.MMD_URL+arr[index].thumb;
                        }
                    }catch(e){}
                    return item;
                })
                return result;
            }
        },
        beforeCreate() {
            vm = this;
        },
        methods: {
            selectText(){
                document.getSelection().selectAllChildren(document.getSelection().focusNode.parentNode);
                document.execCommand('copy');
            },
            copyId(){
                var id=$('.shopDetailsBox span').text();
                document.execCommand('copy');
                layer.msg('复制成功', {offset:['50%','47%']});
            },
            isEmpty:function (obj){
                if(typeof obj == "undefined" || obj == null || obj == ""){
                    return true;
                }else{
                    return false;
                }
            },
            disposeHeadImg:function(url){
               if(this.isEmpty(url)){
                    return '../../static/img/user_img.png';
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        return this.headPath + url;
                    }
                }
            },
            disposeHeadImg1:function(url,type){
               if(this.isEmpty(url)){
                if(type){
                    return '../../static/img/avatar_logo.png';
                }
                return '../../static/img/user_img.png';
                }else{
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        var headType = url.substring(0,7);
                        if(headType=='headImg'){
                            return this.headPath1 + url;
                        }else{
                            if(url.substring(0,6)=='models'){
                                return this.headPath1 + url;
                            }
                            return this.headPath + url;
                        }
                    }
                }
            },
            formatNumber: function(number) {
				if(number < 1000) {
					return number;
				} else {
					return(number / 1000).toFixed(1) + "k";
				}
            },
            loadMore: function() {
                this.queryData.pageNumber++;
                this.addSceneList(this.queryData);
            },
            copySceneId:function(modelid){
                var _this=this;
				$(".getSceneId").val("");
				$(".getSceneId").val(modelid);
				$(".getSceneId").select();
				document.execCommand("Copy");
				if(!_this.win && !_this.mac && !_this.xll) {
					layer.msg("场景ID已复制！",{time: 1000});
				}else{
					layer.msg("场景ID已复制！",{time: 1000});
				}
            },
            infoScene:function(item){
                if($.cookie('openid')){
                    var openUrl = this.infoPath+item.id;
                    window.open(openUrl,"_blank");
                }else{
                   logoinForStore();
                }
            },
            previewScene:function(item){
                if($.cookie('openid')){
                    var openUrl = this.previewPath+'?sceneid='+item.id+'&withPlugin=true';
                    window.open(openUrl,"_blank");
                }else{
                   logoinForStore();
                }
            },
            formatBytes:function(bytes, decimals) {
                if (bytes == 0) return ' -- ';
                if (bytes === 0) return ' -- ';
                var k = 1024;
                var dm = decimals < 0 ? 0 : decimals;
                var sizes = ['B', 'K', 'M', 'G', 'T', 'PB', 'EB', 'ZB', 'YB'];
                var i = Math.floor(Math.log(bytes) / Math.log(k));
                return ' ' + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
            },
            noPlugInPreviewScene:function(item,flag){
                if(flag){
                    var msg = {title:'预览场景',subject:'sceneList',toolInfo:{data:item}};
                    bus.$emit('view',msg);
                    return
                }
                var _this =this;
                window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', {
                    resources: '项目',
                    type:'场景',
                    bigtype:'公开场景',
                    projectName: item.publicname||item.name,
                    projectID: item.id + ''
                })
                if($.cookie('openid')){
                    if(item.type == 4 || item.type == 5) {
                        var sceneUrl = item.path;
                        var sceneName = item.name;
                    }else{
                        var sceneUrl = './client/ThingJS/' + item.userid + '/' + item.id;
                        var sceneName = sceneUrl.split('/').pop();
                    }
                    var mmdId = $.cookie("mmdId");
                    var reData = {
                        'type': 'scene',
                        'preUrl': sceneUrl,
                        'name': sceneName,
                        'mmdId': mmdId,
                        'bgimg':item.off_thumb?item.off_thumb:'http://www.3dmomoda.com:80/models/'+item.id+'.jpg'
                    }
                    let isMmdidLegitimate;
                    try{
                        isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                    }catch(e){
                        isMmdidLegitimate = true;
                    }
                    if(isMmdidLegitimate && !item.off_template){
                        _this.$reqs.post("/api/getPreviewUrl",reData).then(function(result) {
                            if(result.data && result.data.state) {
                                var openUrl ='https://www.thingjs.com' + result.data.content;
                                _this.$reqs.get("/scene/addSceneViewCount?viewId="+item.id+"&type="+item.type, {}).then(function(result) {
                                    window.open(openUrl,"_blank");
                                }).catch(function(error) {
                                    window.open(openUrl,"_blank");
                                    console.log(error);
                                });
                            } else {
                                console.log("获取地址失败！");
                            }
                        }).catch(function(error) {
                            console.log("获取地址失败！"+error);
                        });
                    }else if(item.off_template){
                        var sceneUrl = './client/scenes-encrypt/'+item.attributeStore.sceneOwnerId+'/'+item.attributeStore.resourceId;
                        var sceneName = item.name;
                        reData = {
                            'type': 'scene',
                            'preUrl': sceneUrl,
                            'name': sceneName,
                            'mmdId': mmdId,
                            'imgDev':item.preview?item.preview:'',
                            "isTs": 1
                        }
                        _this.$reqs.post("/api/getPreviewLink",reData).then(function(result) {
                            if(result.data && result.data.state) {
                                window.open(result.data.content,"_blank");
                                // 增加预览次数
                                _this.$reqs.get("/scene/addCampusTemplateView?id="+item.id).then(function(result) {})
                            } else {
                                console.log("获取地址失败！");
                            }
                        }).catch(function(error) {
                            console.log("获取地址失败！"+error);
                        });
                    }
                }else{
                   logoinForStore();
                }
            },
            buyScenes: function(scene) {
                var _this = this;
                if($.cookie('openid')){
                    var imgurl = scene.thumb;
                    var userId = $.cookie('mmdId');
                    var describe = '<span class="_title">购买场景：'+scene.name+'</span><br><br>本场景由场景作者自主出售，并制定售价。您购买场景后将获得此场景的副本，并拥有对此副本的编辑、预览权限。<span ng-show="publicPay">请在对公付款后及时与平台客服联系。谢谢！</span>';
                    var dataArr = {
                        'title':'购买场景',
                        'imgsrc': imgurl,
                        'describe':describe,
                        'price':scene.price,
                        'id':userId,
                        'modelId':'',
                        'sceneId':scene.sceneid,
                        'email':'',
                        'type':'shop',
                        'step':scene.step,
                        'paySource': window.location.href,
                    }
                    layer.open({
                        type: 2,
                        title: false,
                        closeBtn: 0,
                        area: ['585px', '568px'],
                        // content: ['http://127.0.0.1/guide/createPay/payment.html?type=shop&userId='+userId,'no'],
                        content: ['https://www.thingjs.com/static/payment/createPay/payment.html?type=shop&userId='+userId,'no'],
                        skin: 'buyShopDiv',
                        success:function(){
                            document.getElementsByClassName('buyShopDiv')[0].children[1].children[0].contentWindow.postMessage(dataArr,'*');
                            scene.step = '';
                        }
                    });
                    window.addEventListener('message',function(event){
                        if(event.data&&event.data.type&&event.data.type=="newStyle") {
                                $(".buyShopDiv").css({"border-radius":"8px","background-color": "transparent"});
                                $(".buyShopDiv iframe").css("border-radius","8px");
                            }
                        if(event.data=='close'){
                            layer.closeAll();
                        }
                        if(event.data=='success'){
                            _this.showScenePage = false;
                            layer.closeAll();
                            window.AnalysysAgent && window.AnalysysAgent.track('source_pay_success',{
                               'buyPackageName': dataArr.title
                           })
                        }
                    });
                }else{
                   logoinForStore();
                }
			},
            checktCampany:function(message,curType){
                var _this = this;
                if($.cookie("openid")){
                    this.$reqs.get("/user/User_info?token="+$.cookie('token')).then(function(result) {
                        var infos =  result.data;
                        var openPage = '';
                        // if(data.subject) infos.toolInfo = message;
                        if(!infos.phoneVerify) openPage = 'phone';
                        if(!infos.office || !infos.company || !infos.namebyCam) openPage = openPage?openPage+'.info':'info';

                        if(openPage){//缺
                            _this.panelShow = true;
                            infos.type = "shopScene";
                            infos.msg = {title:'购买场景',toolInfo:message,pages:openPage}
                            bus.$emit("openCampanyPanel",{infos:infos});
                        }else{
                            if(curType){
                                _this.buyTempleteScenes(message,curType)
                            }
                        }
                    }).catch(function(error) {
                        console.log(error);
                    });
                }else{
                    logoinForStore();
                }
            },
            buyTempleteScenes: function(scene,curType) {
                var _this = this;
                if($.cookie('openid')){
                    if(curType && curType == 'templeteCampus'){
                        if(scene.price && scene.price!=0){
                            var imgurl = scene.preview;
                            var userId = $.cookie('mmdId');
                            var describe = '<span class="_title">购买场景：'+scene.name+'</span><br><br>本场景由场景作者自主出售，并制定售价。您购买场景后将获得此场景的副本，并拥有对此副本的编辑、预览权限。<span ng-show="publicPay">请在对公付款后及时与平台客服联系。谢谢！</span>';
                            let sceneId = '';
                            if(scene.attributeStore && scene.attributeStore.resourceId){
                                sceneId = scene.attributeStore.resourceId;
                            }
                            var dataArr = {
                                'title':'购买场景',
                                'imgsrc': imgurl,
                                'describe':describe,
                                'price':scene.price,
                                'id':userId,
                                'modelId':'',
                                'sceneId':sceneId,
                                'email':'',
                                'type':'shop',
                                'step':scene.step,
                                'paySource': window.location.href,
                            }
                            layer.open({
                                type: 2,
                                title: false,
                                closeBtn: 0,
                                area: ['585px', '568px'],
                                // content: ['http://127.0.0.1/guide/createPay/payment.html?type=shop&userId='+userId,'no'],
                                content: ['https://www.thingjs.com/static/payment/createPay/payment.html?type=shop&userId='+userId,'no'],
                                skin: 'buyShopDiv',
                                success:function(){
                                    document.getElementsByClassName('buyShopDiv')[0].children[1].children[0].contentWindow.postMessage(dataArr,'*');
                                    scene.step = '';
                                }
                            });
                            window.addEventListener('message',function(event){
                                if(event.data&&event.data.type&&event.data.type=="newStyle") {
                                        $(".buyShopDiv").css({"border-radius":"8px","background-color": "transparent"});
                                        $(".buyShopDiv iframe").css("border-radius","8px");
                                    }
                                if(event.data=='close'){
                                    layer.closeAll();
                                }
                                if(event.data=='success'){
                                    _this.showScenePage = false;
                                    layer.closeAll();
                                    window.AnalysysAgent && window.AnalysysAgent.track('source_pay_success',{
                                    'buyPackageName': dataArr.title
                                })
                                }
                            });
                        }else{
                            this.showBuyTCTips = true;
                            this.showBuyTCInfos = scene;
                        }
                    }
                }else{
                   logoinForStore();
                }
			},
            canelBuyTCTips:function(){
                this.showBuyTCTips = false;
                this.showBuyTCInfos = null;
            },
            buyZeroTempCampus:function(){
                this.showBuyTCTips = false;
                this.buyCopyServerProcess();
            },
            buyCopyServerProcess(){
                let _this = this;
                let scene = this.showBuyTCInfos;
                let sceneId = '';
                let userId = $.cookie('mmdId');
                if(scene.attributeStore && scene.attributeStore.resourceId){
                    sceneId = scene.attributeStore.resourceId;
                }
                var cdkey = $.trim($("input[name=cdkey]").val());
                if(!/^[a-z0-9]{12,12}$/.test(cdkey)){
                    cdkey = "";
                }
                let reqData = {
                    "userId" :userId,
                    "sceneId":sceneId,
                    "type" : 'shop',
                    "cdkey":cdkey,
                    "payment" : 'modou',
                    "paySource":'http://store.thingjs.com/scenes'
                }
                _this.$reqs.post("/scene/getBuyFreeTempScene",reqData).then(function(result) {
                    if(result.data && result.data.state) {
                        _this.$Message.success('场景复制完成！');
                        console.log('复制完成！');
                        _this.showBuyTCInfos = null;
                        return;
                    } else {
                        _this.$Message.success('场景复制失败！');
                        console.log('复制失败！');
                        _this.showBuyTCInfos = null;
                        return;
                    }
                }).catch(function(error) {
                    console.log("接口调用失败！"+error);
                    _this.showBuyTCInfos = null;
                });
            },
            showTooltip: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
            },
            cancelTooltip: function(event) {
                $("div").remove(".tooltips");
            },
            showTooltip1: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
                var leftPx = Number('-' + parseInt($('.tooltips').width())/2);
                $('.modelList_info .shop_author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
            },
            cancelTooltip1: function(event) {
                $("div").remove(".tooltips");
                $('.modelList_info .shop_author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
            },
            sceneType:function(item){
                var sceneTypeJson = {};
                if(item.price>0 && item.userid=="13468"){
                    sceneTypeJson.class = "sceneicon_bg_1";
                    sceneTypeJson.type = "收费场景";
                }else if(item.price==0 && item.userid=="13468"){
                    sceneTypeJson.class = "sceneicon_bg_2";
                    sceneTypeJson.type = "免费场景";
                }else if(item.price>0){
                    sceneTypeJson.class = "sceneicon_bg_1";
                    sceneTypeJson.type = "收费场景";
                }else if(item.price == 0){
                    sceneTypeJson.class = "sceneicon_bg_2"
                    sceneTypeJson.type = "免费场景";
                }
                return sceneTypeJson;
            },
            //初始化场景列表
            initSceneList:function(type,id){
                var _this = this;
                _this.sceneListType = type;
                var url = "/scene/getAllMmdScene";
                if(type=='shopScene'){
                    url = "/scene/getSceneShopList";
                } else if(type == "templateScene"){
                    url = "/scene/campusTemplate";
                }
                this.queryData.pageNumber=1;
                this.$reqs.post(url,this.queryData).then(function(result) {
                    if($('.big_variety .checked').text() == '场景集市' && url == '/scene/getAllMmdScene') return; // 因为全部公开场景加载过慢，会导致场景集市切换夹数据加载问题
                    if(result.data && result.data.state) {
                        _this.sceneList = result.data.content.list;
                        _this.currentClassSceneList = result.data.content.list;
                        _this.allSceneList = result.data.content.list;

                        bus.$emit('changeListCount',result.data.content.totalRow);
                        _this.isLoadComplete = true;
                        _this.isLastPage = result.data.content.totalPage <= result.data.content.pageNumber;
                    } else {
                        console.log("初始化场景列表失败");
                    }
                }).catch(function(error) {
                    console.log("初始化场景列表失败"+error);
                });
            },
            addSceneList:function(data){
                var _this = this;
                var url = "/scene/getAllMmdScene";
                if(_this.sceneListType == 'shopScene'){
                    url = "/scene/getSceneShopList";
                } 
                else if(_this.sceneListType == "templateScene"){
                    url = "/scene/campusTemplate";
                }
                this.$reqs.post(url,data).then(function(result) {
                    if($('.big_variety .checked').text() == '场景集市' && url == '/scene/getAllMmdScene') return; // 因为全部公开场景加载过慢，会导致场景集市切换夹数据加载问题
                    if(result.data && result.data.state) {
                        var content = result.data.content.list;
                        var contentLen = result.data.content.list.length;
                        for(var i = 0; i < contentLen; i++) {
                            _this.sceneList.push(content[i]);
                        }
                        _this.currentClassSceneList = result.data.content.list;
                        _this.allSceneList = result.data.content.list;
                        bus.$emit('changeListCount',result.data.content.totalRow);
                        _this.isLoadComplete = true;
                        _this.isLastPage = result.data.content.totalPage <= result.data.content.pageNumber;
                    } else {
                        console.log("初始化场景列表失败");
                    }
                }).catch(function(error) {
                    console.log("初始化场景列表失败"+error);
                });
            },
            getshopImgList:function(sceneInfo){
                var _this = this;
                return new Promise(function (resolve, reject) {
                    _this.$reqs.get('/scene/getSceneShopImg?sceneId='+sceneInfo.sceneid+'&_ajax=true', {}).then(function(result) {
                        if(result.data && result.data.state) {
                            resolve( result.data );
                        } else {
                            reject( result.data )
                        }
                    }).catch(function(error) {
                        reject( error.data )
                        console.log("初始化场景列表失败"+error);
                    });
                });

            },
            getShopSource:function(sceneInfo){
                var _this = this;
                return new Promise(function (resolve, reject) {
                    _this.$reqs.get('/scene/getTriangularFacetBySceneId?sceneId='+sceneInfo.sceneid+'&_ajax=true', {}).then(function(result) {
                        if(result.data && result.data.state) {
                            resolve( result.data );
                        } else {
                            reject( result.data )
                        }
                    }).catch(function(error) {
                        reject( error.data )
                        console.log("初始化场景列表失败"+error);
                    });
                });
            },
            getAuthorOtherScene:function(sceneInfo){
                this.otherScene = null;
                var otherSceneList = [];
                var _this = this;
                var param = {userid:sceneInfo.userid};

                if(this.otherSceneListAll.length && sceneInfo.userid == this.otherSceneListAll[0].userid){//已请求过的作者场景列表，不在请求
                    showOtherSceneList(this.otherSceneListAll);
                }else{
                    this.$reqs.post("/scene/getSceneShopList",param).then(function(result) {
                        if(result.data && result.data.state) {
                            _this.otherSceneListAll = result.data.content.list;
                            showOtherSceneList(_this.otherSceneListAll);
                        } else {
                            console.log("获取其他场景失败");
                        }
                    }).catch(function(error) {
                        console.log("获取其他场景失败"+error);
                    });
                }

                function showOtherSceneList(list){
                    for(var i = 0; i < list.length; i++ ){
                        if(list[i].sceneid != sceneInfo.sceneid){
                            otherSceneList.push(list[i]);
                        }
                    }
                    var maxSale = 0;
                    for(var i = 0; i < otherSceneList.length; i++){
                        if(otherSceneList[i].salecount >= maxSale){
                            _this.otherScene = otherSceneList[i];
                        }
                    }
                }
            },
            //显示场景详情页
            displayShopScene:function(sceneInfo){
                window.AnalysysAgent && window.AnalysysAgent.track('ResourcesCenter_Click', {
                    resources: '项目',
                    type:'场景',
                    bigtype:'场景集市',
                    projectName: sceneInfo.name,
                    projectID: sceneInfo.id + ''
                })
                if($.cookie('openid')){
                    var _this = this;
                    this.displaySceneInfo =  JSON.parse(JSON.stringify(sceneInfo));
                    this.getAuthorOtherScene(sceneInfo);
                    this.getshopImgList(sceneInfo).then(function(res){
                        _this.shopImgArr = JSON.parse(JSON.stringify( res.content));
                        _this.showScenePage = true;
                    },function(){
                        _this.shopImgArr = JSON.parse(JSON.stringify( res.content));
                    })
                    this.getShopSource(sceneInfo).then(function(res){
                    _this.shopSource =  JSON.parse(JSON.stringify( res.content));
                    },function(){})
                }else{
                    logoinForStore();
                }
            },
            recharge:function(){
                var index = layer.open({
                    type: 2,
                    move: false,
                    title: false,
                    closeBtn: 0,
                    area: ['535px', '416px'],
                    resize: false,
                    content:['https://www.thingjs.com/static/payment/createPay/payRecharge.html?userId='+$.cookie('mmdId'), 'no'],
                    skin: 'buyRecharge',
                    success:function(){
                        document.getElementsByClassName('buyRecharge')[0].querySelector('.layui-layer-content').children[0].contentWindow.postMessage({paySource:location.href}, '*');
                    }
                });
                window. addEventListener ('message', function(event) {
                    if(event.data&&event.data.type&&event.data.type=="newStyle") {
                        $(".buyRecharge").css({'border-radius':'8px','backgroundColor':'rgba(0,0,0,0)'});
                        $(".buyRecharge iframe").css({'border-radius':'8px','backgroundColor':'rgba(0,0,0,0)'});
                    }
                    if(event.data=='closeRecharge'){
                        layer.close(index);
                    }
                });
            },
            setUlWidth:function(){
                var len = $(".shopimgLi").width()*$(".shopimgLi").length;
                $(".shopimgUl").width(len);
            },
            setSmallUlWidth:function(){
                var len = ($(".smallShopimgLi").width()+20)*$(".smallShopimgLi").length;
                $(".smallShopimgUl").width(len);
            },
            selectSmallImg:function(num){
                for(var i = 0;i < $(".smallShopimgLi").length; i++){
                    $(".smallShopimgLi").eq(i).css({"border":"2px solid #fafafa"})
                }
                $(".smallShopimgLi").eq(num-1).css({"border":"2px solid #ff6803"})
            },
            focusSmallImg:function(ev){
                this.currentImgNum =  $(ev.target).parent().index()+1;
                this.selectSmallImg(this.currentImgNum);
                this.moveBigImg();
            },
            moveBigImg:function(){
                if(!$(".shopimgUl").is(":animated")){
                    this.setUlWidth();
                    var changeWidth = $(".shopimgUl").find("li").width();
                    var changeLeft = -changeWidth*(this.currentImgNum-1);
                    $(".shopimgUl").animate({left:changeLeft+'px'});
                }
            },
            moveLeft:function(){
                if(!$(".shopimgUl").is(":animated")){
                    this.setUlWidth();
                    var currentLeft = $(".shopimgUl").position().left;
                    var changeWidth = $(".shopimgUl").find("li").width();
                    if(currentLeft < 0){
                        this.currentImgNum = parseInt(-currentLeft/changeWidth);
                        this.selectSmallImg(this.currentImgNum);
                        var changeLeft = currentLeft+changeWidth;
                    }
                    $(".shopimgUl").animate({left:changeLeft+'px'});
                }
            },
            moveRight:function(){
                if(!$(".shopimgUl").is(":animated")){
                    this.setUlWidth();
                    var currentLeft = $(".shopimgUl").position().left;
                    var changeWidth = $(".shopimgUl").find("li").width();

                    if(-currentLeft < ($(".shopimgUl").find("li").length-1)*changeWidth){
                        this.currentImgNum = parseInt(-currentLeft/changeWidth+2);
                        this.selectSmallImg(this.currentImgNum);
                        var changeLeft = currentLeft-changeWidth;
                    }
                    $(".shopimgUl").animate({left:changeLeft+'px'});
                }
            },
            moveSmallLeft:function(){
                if(!$(".smallShopimgUl").is(":animated")){
                    this.setSmallUlWidth();
                    var currentLeft = $(".smallShopimgUl").position().left;
                    var changeWidth = $(".smallShopimgUl").find("li").width()+20;
                    if(currentLeft < 0){
                        var changeLeft = currentLeft+changeWidth;
                    }
                    $(".smallShopimgUl").animate({left:changeLeft+'px'});
                }
            },
            moveSmallRight:function(){
                if(!$(".smallShopimgUl").is(":animated")){
                    this.setSmallUlWidth();
                    var currentLeft = $(".smallShopimgUl").position().left;
                    var changeWidth = $(".smallShopimgUl").find("li").width()+20;

                    if(-currentLeft < ($(".smallShopimgUl").find("li").length-4)*changeWidth){
                        // this.currentImgNum = parseInt(-currentLeft/changeWidth+2);
                        var changeLeft = currentLeft-changeWidth;
                    }
                    $(".smallShopimgUl").animate({left:changeLeft+'px'});
                }
            },
            screenScene:function(id){
                var tmpSceneList = [];
                for(var i = 0; i < this.allSceneList.length; i++){
                    if(id == "chargeScene"){
                        if(this.allSceneList[i].price > 0){
                            tmpSceneList.push(this.allSceneList[i]);
                        }
                    }else if(id == "freeScene"){
                         if(this.allSceneList[i].price == 0){
                            tmpSceneList.push(this.allSceneList[i]);
                        }
                    }else if(id == 1){
                        tmpSceneList.push(this.allSceneList[i]);
                    }
                }
                this.sceneList = JSON.parse(JSON.stringify(tmpSceneList));
                this.currentClassSceneList = JSON.parse(JSON.stringify(tmpSceneList));
                bus.$emit('changeListCount',this.sceneList.length);
            },
            searchScene:function(){
                var tmpSceneList = [];
                if(this.queryData.keyWord){
                    for(var i = 0; i < this.currentClassSceneList.length; i++){
                        if(this.currentClassSceneList[i].name.indexOf(this.queryData.keyWord) != -1){
                            tmpSceneList.push(this.currentClassSceneList[i]);
                        }
                    }
                }else{
                    tmpSceneList = JSON.parse(JSON.stringify(this.currentClassSceneList));
                }
                this.sceneList = JSON.parse(JSON.stringify(tmpSceneList));
            },
            searchSingleSceneById:function(id){
                if(id){
                    for(var i = 0; i < this.currentClassSceneList.length; i++){
                        if(this.currentClassSceneList[i].id == id){
                            this.singleScene_mmd = this.currentClassSceneList[i];
                            this.displayShopScene(this.singleScene_mmd);
                            this.checkCampany(this.singleScene_mmd);
                            break;
                        }
                    }
                }
            },
            positiveSequence:function(array,term){
                var sceneInfo = array;
                sceneInfo.sort(function (a, b){
                    var aTerm = new Date(a[term]);
                    var bTerm = new Date(b[term]);
                    return aTerm - bTerm;
                });
            },
            reverseOrder:function(array,term){
                // var sceneInfo = array;
                this.sceneList.sort(function (a, b){
                    var aTerm = new Date(a[term]);
                    var bTerm = new Date(b[term]);
                    return bTerm - aTerm;
                });
            },
            sortScene:function(){
                if(this.queryData.sort == "zonghe"){
                    this.reverseOrder(this.sceneList,"salecount");
                }else if(this.queryData.sort == "buy"){
                    this.reverseOrder(this.sceneList,"salecount");
                }else if(this.queryData.sort == "browse"){
                    this.reverseOrder(this.sceneList,"salecount");
                }else if(this.queryData.sort == "createTime"){
                     this.reverseOrder(this.sceneList,"createtime");
                }else{
                    // this.sceneList = JSON.parse(JSON.stringify(this.currentClassSceneList));
                }
            },
            querySceneList:function(){
                this.searchScene();
                this.sortScene();
                bus.$emit('changeListCount',this.sceneList.length);
            },
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            checkCampany:function(message){
                var _this = this;
                if($.cookie("openid")){
                    this.$reqs.get("/user/User_info?token="+$.cookie('token')).then(function(result) {
                        var infos =  result.data;
                        var openPage = '';
                        // if(data.subject) infos.toolInfo = message;
                        if(!infos.phoneVerify) openPage = 'phone';
                        if(!infos.office || !infos.company || !infos.namebyCam) openPage = openPage?openPage+'.info':'info';

                        if(openPage){//缺
                            _this.panelShow = true;
                            infos.type = "shopScene";
                            infos.msg = {title:'购买场景',toolInfo:message,pages:openPage}
                            bus.$emit("openCampanyPanel",{infos:infos});
                        }else{
                            _this.buyScenes(message);
                        }
                    }).catch(function(error) {
                        console.log(error);
                    });
                }else{
                    logoinForStore();
                }
            },
            showPanel:function(){
                if($.cookie('openid')){
                    this.panelShow = true;
                }
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
                window.parent.postMessage('closePanel','*');
            },
            showScene:function(){
                this.showScenePage=false;
                if(window.location.href.indexOf("userid")>0){
                    window.open(window.location.href.split("&")[0],'_self');
                }
            },
            saleItem(item,flag = true) {
                if(flag){
                    var msg = {title:"购买项目",subject:'project_buy_shopScenes',toolInfo:{data:item}};
                    bus.$emit('view',msg);
                    return
                }
                var _this =this;
                if($.cookie('openid')){
                    // this.panelShowD = true;
                    var name = item.projectName?item.projectName:item.name;
                    var msg = {
                        "subject":'saleProject',
                        "projectName":"购买项目："+name,
                        type:'ThingJS_ForScene',
                        id:item.id
                    }

                    var sceneUrl = './client/ThingJS/' + item.userid + '/' + item.id;
                    var sceneName = sceneUrl.split('/').pop();
                    var mmdId = $.cookie("mmdId");
                    var reData = {
                        'type': 'scene',
                        'preUrl': sceneUrl,
                        'name': sceneName,
                        'mmdId': mmdId,
                        'bgimg':item.off_thumb?item.off_thumb:'http://www.3dmomoda.com:80/models/'+item.id+'.jpg'
                    }
                    let isMmdidLegitimate;
                    try{
                        isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                    }catch(e){
                        isMmdidLegitimate = true;
                    }
                    if(isMmdidLegitimate){
                        _this.$reqs.post("/api/getPreviewUrl",reData).then(function(result) {
                            if(result.data && result.data.state) {
                                var openUrl ='https://www.thingjs.com' + result.data.content;
                                _this.$reqs.get("/scene/addSceneViewCount?viewId="+item.id+"&type="+item.type, {}).then(function(result) {
                                    msg.url = openUrl;
                                    bus.$emit("sales",msg);
                                    // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                }).catch(function(error) {
                                    msg.url = '';
                                    bus.$emit("sales",msg);
                                    // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                    console.log(error);
                                });
                            } else {
                                msg.url = '';
                                bus.$emit("sales",msg);
                                // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                console.log("获取地址失败！");
                            }
                        }).catch(function(error) {
                            msg.url = '';
                            bus.$emit("sales",msg);
                            // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                            console.log("获取地址失败！"+error);
                        });
                    }
                }else{
                   logoinForStore();
                }
            },
            hidePanelD:function(success) {
                var _this = this;
                this.panelShowD = false;
                window.parent.postMessage('closePanel','*');
            },
            processingTime: function(time) {
                const isDateTime = new Date(time);
                const year = isDateTime.getFullYear();
                const month = String(isDateTime.getMonth() + 1).padStart(2, '0');
                const day = String(isDateTime.getDate()).padStart(2, '0');
                const hours = String(isDateTime.getHours()).padStart(2, '0');
                const minutes = String(isDateTime.getMinutes()).padStart(2, '0');
                const seconds = String(isDateTime.getSeconds()).padStart(2, '0');
                var dateStr = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
                return dateStr;
            },
        },
        beforeDestroy () {
            bus.$off("sceneListChangeEvent");
            bus.$off("changeSceneList");
            bus.$off("changeAllSceneList");
            bus.$off("addSceneList");
            bus.$off("showSceneNull");
            bus.$off("addProjectlList");
        },
        mounted() {
            if(shield.shieldWords.indexOf($("#keyword").val())=='-1'){
                this.queryData.keyWord = $("#keyword").val();
            }
            this.queryData.sort = $('.active').attr('data-sort');
            this.initSceneList('mmdScene');
            bus.$on("sceneListChangeEvent", (id) => {
                this.initSceneList(id);
                //切换是否收费场景
                // this.screenScene(id);
                // if(this.queryData){
                    // this.querySceneList();
                // }
            });
            bus.$on("sceneShopfromMMD", (data) => {
                bus.$emit('sceneCheck');
                if(data.action) this.initSceneList(data.type,data.id);
                else this.initSceneList(data.type)
            });
            bus.$on("changeSceneList", (data) => {
                this.queryData = JSON.parse(JSON.stringify(data));
                if(this.queryData.type == ""){
                    this.currentClassSceneList = JSON.parse(JSON.stringify(this.allSceneList));
                }
                this.querySceneList();
            });
            bus.$on("addProjectlList", (data) => {
                this.loadMore();
            });
            bus.$on("showSceneNull", (data) => {
                this.sceneList=[];
                bus.$emit('changeListCount','-1');
                this.isLastPage = true;
            });
            bus.$on("changeAllSceneList", (data) => {
                this.sceneList=[];
                this.queryData = data;
                this.addSceneList(data);
            });
            bus.$on("addSceneList", (data) => {
                this.queryData = data;
                this.addSceneList(data);
            });
            bus.$on("shopScene", (data) => {
                data.infos.step = data.step;
                this.buyScenes(data.infos);
            });
            bus.$on("sceneList",(data) => {
                this.noPlugInPreviewScene(data,false);
            })
            // shopScenes.vue购买留资拦截
            bus.$on("project_buy_shopScenes",(data) => {
                // console.log('project_buy_shopScenes')
                this.saleItem(data,false);
            })
            if(window.devicePixelRatio<'1.5' && window.devicePixelRatio >= '1.2'){
                $('.shopSceneContainer').css({'transform':'translate(-498px,-293px)scale(0.99)'});
            }else if(window.devicePixelRatio >= '1.5'){
                $('.shopSceneContainer').css({'transform':'translate(-498px,-286px)scale(0.85)'});
            }else{
                $('.shopSceneContainer').css({'transform':'translate(-498px,-324px)'});
            }
            window.onresize= function(){
                if(window.devicePixelRatio<'1.5' && window.devicePixelRatio >= '1.2'){
                    $('.shopSceneContainer').css({'transform':'translate(-498px,-293px)scale(0.99)'});
                }else if(window.devicePixelRatio >= '1.5'){
                    $('.shopSceneContainer').css({'transform':'translate(-498px,-286px)scale(0.85)'});
                }else{
                    $('.shopSceneContainer').css({'transform':'translate(-498px,-324px)'});
                }
            };
            if (this.isMobile()) {
                this.queryData.isAPP = true;
            } else {
                this.queryData.isAPP = false;
            }
        },
        filters:{
            priceUnit:function(value){
                return value + "元";
            },
            highLightMsg:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                         return value;
                        // return value.length>20 ? value.substring(0, 20)+"..." : value;
                    }
                }else{
                     return value;
                    // return value.length>20 ? value.substring(0, 20)+"..." : value;
                }
            },
            highLightkeyWord:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }
        }
    }
</script>
<style>
    @import '../assets/css/shopscenes.css';
    @import '../assets/css/modelList.css';
</style>



// WEBPACK FOOTER //
// src/components/ShopScenes.vue